// import jQuery from 'CommonScripts/jquery-1.10.2';

(function(window, document, $) {
  $(document).ready(function() {
    /* Create as a function, so it can be triggered by the MMC after loading */
    window.loadTexturePickerSpot = function($target) {
      if (!$target) {
        $target = "main";
      }
      //$.components.registerComponent($target + ' ' + 'section.texture-picker-spot', function ($root) {
      var $root = document.querySelectorAll(
        $target + " " + "section.texture-picker-spot"
      );
      $root = $($root);

      var texturePicker = {
          dom: {
            info: $root.find(".texture-info-box"),
            infoId: $root.find(".texture-info-id"),
            infoTitle: $root.find(".texture-info-title"),
            infoImage: $root.find(".texture-info-image"),
            textures: $root.find(".texture-option"),
            window: $(window)
          },
          set: {
            arrowWidth: 10,
            arrowHeight: 10,
            hideClass: "is-hidden",
            tooltipTimeout: null,
            tooltipTimeoutStatus: false,
            tooltipDelay: 400
          },
          fn: {
            showInfoBox: function(e) {
              var $target = $(e.target);
              if ($target.filter($dom.textures).length === 0)
                $target = $target.parents($dom.textures);

              $fn.setInfoText(
                $target.data("id"),
                $target.data("title"),
                $target.data("sample-img-src")
              );
              $dom.infoImage.load(
                (function(texture) {
                  // only show info-box after image has loaded and use a local variable to avoid curry-bugs.

                  /* Add small delay to not immediately open tooltip on hover */
                  if ($set.tooltipTimeoutStatus) {
                    clearTimeout($set.tooltipTimeout);
                    $set.tooltipTimeoutStatus = false;
                  }

                  $set.tooltipTimeoutStatus = true;
                  $set.tooltipTimeout = setTimeout(function() {
                    const image = $(e.target);
                    const parent = image.closest(".texture-picker-spot");
                    const infoBox = parent[0].querySelector(
                      ".texture-info-box"
                    );
                    infoBox.classList.remove($set.hideClass);
                    $fn.placeInfoBox(texture);

                    $set.tooltipTimeoutStatus = false;
                  }, $set.tooltipDelay);
                })($target)
              );
            },
            hideInfoBox: function() {
              /* Cancel opening tooltip when leaving before the timeout is done */
              if ($set.tooltipTimeoutStatus) {
                clearTimeout($set.tooltipTimeout);
                $set.tooltipTimeoutStatus = false;
              }

              $fn.setInfoText("", "", "");
              $dom.info.addClass($set.hideClass);
            },
            placeInfoBox: function($target) {
              var targetPos = $target.position();
              var targetHeight = $target.outerHeight();
              var targetWidth = $target.outerWidth();
              var targetBorder = parseInt($target.css("marginRight"));
              var infoBoxWidth = $dom.info.width();
              var infoBoxBorder = parseInt($dom.info.css("borderRight"));
              var windowWidth = $dom.window.width();
              var windowTop = $dom.window.scrollTop();
              var imageHeight =
                ($dom.infoImage.width() * $dom.info.find("img").height()) /
                $dom.info.find("img").width();

              // Reset
              /* First set the height */
              $dom.info.css({
                height: imageHeight
              });

              var infoBoxHeight = $dom.info.outerHeight();
              /* Then set the left and top, depending on the new height */
              $dom.info.css({
                left: targetPos.left - targetBorder,
                top:
                  targetPos.top -
                  infoBoxHeight -
                  parseInt($target.css("marginBottom"))
              });
              $dom.info.removeClass("info-box-left info-box-bottom");

              // Too much to the right?
              var right =
                $dom.info.offset().left + infoBoxWidth - 2 * targetBorder;
              if (right > windowWidth) {
                // Move to the left
                $dom.info.css({
                  left:
                    targetPos.left - infoBoxWidth + targetWidth + targetBorder
                });
                $dom.info.addClass("info-box-left");
              }

              // Too high up?
              var top = $dom.info.offset().top;
              if (top < windowTop) {
                // Move down
                $dom.info.css({
                  top:
                    targetPos.top +
                    targetHeight +
                    parseInt($target.css("marginBottom"))
                });
                $dom.info.addClass("info-box-bottom");
              }
            },
            setInfoText: function(id, title, imageSrc) {
              $dom.infoId.text(id);
              $dom.infoTitle.text(title);
              $dom.infoImage.attr("src", imageSrc);
            },
            toggleInfoBox: function(e) {
              if ($dom.info.is(":visible")) $fn.hideInfoBox();
              else $fn.showInfoBox(e);
            }
          }
        },
        /* Add quick access variables to be used in local function
         * Keep main variable name in case it needs to be shared with other JS files
         */
        $dom = texturePicker.dom,
        $set = texturePicker.set,
        $fn = texturePicker.fn;

      $root.on(
        {
          mouseenter: $fn.showInfoBox,
          mouseleave: $fn.hideInfoBox,
          click: $fn.toggleInfoBox
        },
        ".texture-option"
      );
      //});

      /* When the registerComponent is triggered by the MMC (when target is not main), initiate the components again */
      if ($target != "main") {
        $.components.compInit();
      }
    };
    window.loadTexturePickerSpot();
  });
})(window, document, jQuery);
